import React from 'react';
import { Select } from "@vitalsource/vstui";
import {VstInput} from 'vstui';
import { toastUtils } from '../../utils/toast-utils';

// Renders the Registration Page
class RegistrationContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: (this.props.email || ''), emailFailure: false,
      emailConfirmation: '', emailConfirmationFailure: false,
      firstName: '', firstNameFailure: false,
      lastName: '', lastNameFailure: false,
      password: '', pwdFailure: false,
      passwordConfirmation: '', pwdConfirmationFailure: false,
      questionId: 6,
      questionResponse: '', questionResponseFailure: false,
      emailStatus: (this.props.emailStatus || ''),
      tos: (Fraction.User && Fraction.User.eulaAccepted) || false,
      tosFailure: false,
      emailLocked: (Fraction.User && Fraction.User.emailLocked) || this.props.viaSSO,
    };
    this._checkUserEmail = this._checkUserEmail.bind(this);
    this._updateEmail = this._updateEmail.bind(this);
    this._resetEmail = this._resetEmail.bind(this);
    this._validateEmail = this._validateEmail.bind(this);
    this._validateEmailConfirmation = this._validateEmailConfirmation.bind(this);
    this._validatePassword = this._validatePassword.bind(this);
    this._validatePasswordConfirmation = this._validatePasswordConfirmation.bind(this);
    this._validateFirstName = this._validateFirstName.bind(this);
    this._validateLastName = this._validateLastName.bind(this);
    this._validateQuestionResponse = this._validateQuestionResponse.bind(this);
    this._validateTOS = this._validateTOS.bind(this);
    this._validateRecaptcha = this._validateRecaptcha.bind(this);
    this._submitForm = this._submitForm.bind(this);
    this._validateAllFields = this._validateAllFields.bind(this);
    this._registerUser = this._registerUser.bind(this);
    this._updateInput = this._updateInput.bind(this);
    this._emailLockedModal = this._emailLockedModal.bind(this);
    this._onEmailBlur = this._onEmailBlur.bind(this);
    this._onEmailConfirmationBlur = this._onEmailConfirmationBlur.bind(this);
    this._onPasswordBlur = this._onPasswordBlur.bind(this);
    this._onPasswordConfirmationBlur = this._onPasswordConfirmationBlur.bind(this);

    this.accountContainerRef = React.createRef();
    this.pwdConfirmInputRef = React.createRef();
  }

  componentDidMount() {
    // Get the necessary recaptcha keys
    /*
    // Disabling for now because of BO-3947 - User in China cannot create Bookshelf accounts due to reCaptcha
    Jigsaw.User.generateCaptcha((response) => {
      this.setState(response.data);
      Fraction.Helpers.loadRecaptchaScript();
    });
    */
  }

  componentDidUpdate(){
    $("#login-return").val(document.location.protocol+"//"+document.location.host);
    Fraction.Helpers.bindLinks();
  }

  _checkUserEmail(callback) {
    if (this.state.emailLocked) {
      return callback(true);
    }
    if (!this._validateEmail()) {
      return callback(false);
    }
    (function(container){
      Jigsaw.User.exists(container.state.email, function(response){
        if (response.response==="error"){
          callback(false);
        } else {
          if (response.data.exists){
            container.setState({emailStatus: 'exists', emailInvalid: false});
            callback(false);
          } else if (response.data.approved) {
            container.setState({emailStatus: 'approved', emailInvalid: false});
            callback(false);
          } else {
            Fraction.Router.setRoute('user/registration/new', true);
            container.setState({emailStatus: 'available', emailInvalid: false});
            callback(true);
          }
        }
      });
    })(this);
  }

  _updateEmail(e) {
    if (!this.state.emailLocked) {
      this.setState({email: e.target.value});
    }
  }

  _resetEmail(e, showError) {
    e.preventDefault();
    if (showError){
      this.setState({pwdFailure: false, pwdConfirmationFailure: false});
    }

    if (typeof this.props.resetEmailCallback === "function") {
      this.props.resetEmailCallback();
    } else {
      Fraction.Router.setRoute('user/registration', true);
      this.setState({email: '', emailStatus: ''});
    }
  }

  _validateEmail(){
    if (this.state.emailLocked) {
      return true;
    }

    if (!this.props.isValidEmail(this.state.email)){
      //if (this.state.email.length > 0){
        this.setState({emailInvalid: i18n.t('signin.invalid-email')});
      //}
      return false;
    }
    this.setState({emailInvalid: false});
    return true;
  }

  _validateEmailConfirmation(){
    if (this.state.emailLocked) {
      return true;
    }

    if (this.state.emailConfirmation !== this.state.email) {
      this.setState({emailConfirmationInputFailure: i18n.t('registration.email-no-match')});
      return false;
    }
    this.setState({emailConfirmationInputFailure: false});
    return true;
  }

  _validatePassword(){
    if (!Fraction.Helpers.Users.isValidPassword(this.state.password)){
      this.setState({pwdFailure: i18n.t('registration.valid-password')});
      return false;
    }
    this.setState({pwdFailure: false});
    return true;
  }

  _validatePasswordConfirmation(){
    var pwdConfirmationInput = this.pwdConfirmInputRef.current;
    if (this.state.passwordConfirmation!==this.state.password){
      if (this._validatePassword() && this.state.passwordConfirmation.length > 0){
        this.setState({pwdConfirmationFailure: i18n.t('registration.pwd-no-match')});
      }
      return false;
    }
    this.setState({pwdConfirmationFailure: false});
    return true;
  }

  _validateInputExistence(errorKey, value){
    if (value.length === 0){
      const newState = {};
      newState[errorKey] = i18n.t('registration.please-fill-out');
      this.setState(newState);
      return false;
    }
    return true;
  }

  _validateFirstName(e){
    return this._validateInputExistence("firstNameFailure", this.state.firstName);
  }

  _validateLastName(e){
    return this._validateInputExistence("lastNameFailure", this.state.lastName);
  }

  _validateQuestionResponse(e){
    return this._validateInputExistence("questionResponseFailure", this.state.questionResponse);
  }

  _validateTOS(e){
    if ((Fraction.User && Fraction.User.eulaAccepted) || this.state.tos){
      return true;
    } else {
      this.setState({tosFailure: i18n.t('registration.please-fill-out')});
      return false;
    }
  }

  _validateRecaptcha(e){
    return true; // disabling for now because of BO-3947 - User in China cannot create Bookshelf accounts due to reCaptcha
  }

  _submitForm(e) {
    this._checkUserEmail(function(emailIsValid) {
      if (emailIsValid) {
        this._registerUser();
      } else {
        $(this.accountContainerRef.current).scrollTop(0);
      }
    }.bind(this));
    e.preventDefault();
  }

  _validateAllFields() {
    // This way they will all run so we get every error at once.
    const email = this._validateEmail();
    const emailConfirmation = this._validateEmailConfirmation();
    const firstName = this._validateFirstName();
    const lastName = this._validateLastName();
    const questionResponse = this._validateQuestionResponse();
    const password = this._validatePassword();
    const passwordConfirmation = this._validatePasswordConfirmation();
    const tos = this._validateTOS();
    // validate the recaptcha last so that you only get that error when everything else checks out
    return (email && emailConfirmation && firstName && lastName &&
           questionResponse && password && passwordConfirmation && tos &&
           this._validateRecaptcha());
  }

  _registerUser(e){
    if (this._validateAllFields()){
      $(".registration-create").attr("disabled","disabled");
      var userObject = {
        lastBrandAccessed: Fraction.Brand.jigsawBrand,
        email: this.state.email,
        password: this.state.password,
        password_confirmation: this.state.passwordConfirmation,
        question_id: this.state.questionId,
        question_response: this.state.questionResponse,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        eula_accepted: this.state.tos,
        notify: false
      };
      if (this.props.completeAccount){
        // We're actually trying to complete an account, not create one!
        Fraction.Helpers.setUserInfo(userObject, function(response){
          if (response.isSuccess()){
            Fraction.Helpers.redirectMe();
          } else {
            $(".registration-create").removeAttr("disabled");
            // some error happened
          }
        });
      } else {
        if (this.props.viaSSO){
          this.props.setInfo(userObject);
          //container.props.mergeAccount({email: container.state.email, password: container.state.password});
        } else {
          Fraction.Helpers.addLoader('#bookshelf');
          userObject.recaptchaResponse = $(".g-recaptcha-response").val();
          Jigsaw.User.create(userObject, function(response) {
            if (response.isSuccess()) {
              window.location = "/";
            } else {
              Fraction.Helpers.removeLoader('#bookshelf');
              $(".registration-create").removeAttr("disabled");
              if (response.code === 429 || true) {
                // too many requests...but it's the same error...
                toastUtils.notify(i18n.t('registration.too-many-create-requests'), { type: "error" });
              }
            }
          });
        }
      }
    }
  }

  _updateInput(e){
    var input = $(e.currentTarget);
    var o = {};
    if (input.attr("type")==="checkbox"){
      o[input.data('key')] = input.is(":checked");
    } else {
      o[input.data('key')] = input.val();
    }
    o[`${input.data('key')}Failure`] = false;
    this.setState(o);
  }

  _emailLockedModal(e){
    e.preventDefault();
    Fraction.Helpers.showModal({title: i18n.t('registration.email-locked'), content: <span>{i18n.t('registration.cannot-change-popup')}</span>});
    return false;
  }


  // Using separate functions for event handlers, because both a synthetic event and a native event
  // are being passed into the function. We'd normally expect a single event parameter, and are using
  // the second parameter to pass custom data.
  _onEmailBlur(e){
    this._validateEmail();
    this._validateEmailConfirmation();
  }

  _onEmailConfirmationBlur(e){
    this._validateEmailConfirmation();
  }

  _onPasswordBlur(e){
    this._validatePassword();
    this._validatePasswordConfirmation();
  }

  _onPasswordConfirmationBlur(e) {
    this._validatePasswordConfirmation();
  }

  render(){
    var redirect = document.location.protocol+"//"+document.location.host;
    var failure = document.location.protocol+"//"+document.location.host+"/#/user/registration/failure";
    if (Fraction.redirectAfterSignIn){
      redirect+="/#/"+Fraction.Helpers.redirectUrl();
    }
    var existenceContent = <div />;
    if (this.state.emailStatus==="exists"){
      existenceContent = (<div className="existence-box">
                            <div className="existence-header">{i18n.t('registration.email-in-use')}</div>
                            <div className="existence-description">{i18n.t('registration.email-in-use-text')}</div>
                            <div className="existence-buttons">
                              {Fraction.Brand.Signin.enabled && 
                                <button type="button" className="submit" onClick={function(){ Fraction.Router.setRoute('user/signin'); }}>
                                  {i18n.t('signin.signin-button')}
                                </button>
                              }
                              {Fraction.Brand.ForgotPassword.enabled && <button type="button" className="submit" onClick={function(){ Fraction.Router.setRoute('user/forgot'); }}>{i18n.t('signin.reset-password')}</button>}
                           </div>
                          </div>);
    } else if (this.state.emailStatus==="approved"){
      existenceContent = (<div className="existence-box">
                            <div className="existence-header">{i18n.t('registration.pre-approved')}</div>
                            <div className="existence-description">{window.toHTML(i18n.t('registration.pre-approved-text', {url: '#'}))}</div>
                          </div>);
    }
    return (
      <div onScroll={this.props.redraw} ref={this.accountContainerRef}>
        { Fraction.Helpers.modalToShow }

        <div className="account registration">

          {this.props.renderAccountGraphic("register")}

          <div className="account-content registration">

            <div className={"step register-form"}>
              <h1 className="large">
                {(this.props.completeAccount || this.state.emailLocked) ? i18n.t('sso.registration-heading') : i18n.t('registration.registration-heading')}
              </h1>
              <h1 className="small">
                {(this.props.completeAccount || this.state.emailLocked) ? i18n.t('sso.registration-heading') : i18n.t('registration.registration-heading')}
              </h1>

              <form method="post" id="registration-form" onSubmit={this._submitForm} noValidate>
                {this.state.emailLocked &&
                  <div className="email-field set-email">
                    <span>
                      {this.state.email}
                      {!this.props.completeAccount && this.props.viaSSO ?
                        <span>
                        <a href="#" className="noButton" onClick={this._resetEmail}> {i18n.t('registration.change-email')}</a></span> :
                        <div className="email-locked">{i18n.t('registration.cannot-change-email')} <button className="noButton" onClick={this._emailLockedModal}>{i18n.t('registration.learn-more')}</button></div>
                      }
                    </span>
                  </div>
                }
                <div className="duplex">
                  <VstInput required
                            id="first-name-input"
                            label={i18n.t('base.firstname')}
                            failure={this.state.firstNameFailure}
                            className="half"
                            type="text"
                            options="medium"
                            name="user[first_name]"
                            data-key="firstName"
                            onChange={this._updateInput}
                            onBlur={this._validateFirstName}
                            value={this.state.firstName} />
                  <VstInput required
                            id="last-name-input"
                            label={i18n.t('base.lastname')}
                            failure={this.state.lastNameFailure}
                            className="half"
                            type="text"
                            options="medium"
                            name="user[last_name]"
                            data-key="lastName"
                            onChange={this._updateInput}
                            onBlur={this._validateLastName}
                            value={this.state.lastName} />
                </div>

                {!this.state.emailLocked &&
                  <VstInput required
                            id="email-field"
                            label={i18n.t('base.email')}
                            type="email"
                            name="user[email]"
                            options="medium"
                            failure={this.state.emailInvalid}
                            onBlur={this._onEmailBlur}
                            onChange={this._updateEmail}
                            value={this.state.email}
                            disabled={this.state.emailLocked} />
                }

                {!this.props.viaSSO && existenceContent}

                {!this.state.emailLocked &&
                  <VstInput required
                            failure={this.state.emailConfirmationInputFailure}
                            id="email-confirm-input"
                            type="email"
                            name="user[confirm_email]"
                            label={i18n.t('base.confirm-email')}
                            options="medium"
                            data-key="emailConfirmation"
                            onBlur={this._onEmailConfirmationBlur}
                            onChange={this._updateInput}
                            value={this.state.emailConfirmation} />
                }
                <div className="duplex">
                  <VstInput required
                            failure={this.state.pwdFailure}
                            label={i18n.t('base.password')}
                            id="password-input"
                            type="password"
                            className="password-input"
                            name="user[password]"
                            data-key="password"
                            options="medium"
                            onBlur={this._onPasswordBlur}
                            onChange={this._updateInput}
                            tooltip={i18n.t('registration.valid-password')}
                            value={this.state.password} />
                  <VstInput required
                            failure={this.state.pwdConfirmationFailure}
                            label={i18n.t('base.confirm-password')}
                            id="password-confirm-input"
                            ref={this.pwdConfirmInputRef}
                            type="password"
                            options="medium"
                            name="user[password_confirmation]"
                            data-key="passwordConfirmation"
                            onBlur={this._onPasswordConfirmationBlur}
                            onChange={this._updateInput}
                            value={this.state.passwordConfirmation} />
                </div>
                <Select 
                  required
                  label={i18n.t('registration.security-question')}
                  id="security-question-input"
                  className="security-question"
                  name="user[question_id]"
                  onChange={this._updateInput}
                  data-key="questionId"
                  value={this.state.questionId}
                  fullWidth
                >                           
                  <option value={6}>{i18n.t('registration.security-question6')}</option>
                  <option value={7}>{i18n.t('registration.security-question7')}</option>
                  <option value={8}>{i18n.t('registration.security-question8')}</option>
                  <option value={9}>{i18n.t('registration.security-question9')}</option>
                  <option value={10}>{i18n.t('registration.security-question10')}</option>
                </Select>
                <VstInput required
                          label={i18n.t('registration.security-answer')}
                          failure={this.state.questionResponseFailure}
                          id="security-answer-input"
                          type="text"
                          options="medium"
                          name="user[question_response]"
                          data-key="questionResponse"
                          onChange={this._updateInput}
                          onBlur={this._validateQuestionResponse}
                          value={this.state.questionResponse} />
                {(!Fraction.User || !Fraction.User.eulaAccepted) &&
                  <VstInput required
                            label={window.toHTML(i18n.t('registration.accept-tos', {eulaurl: Fraction.Brand.Terms.url || i18n.t('locations.zendesk-tou'), privacyURL: Fraction.Brand.Privacy.url || i18n.t('locations.zendesk-privacy'), cookieURL: Fraction.Brand.Cookies.url || i18n.t('locations.zendesk-cookies') }))}
                            id="tos"
                            options="box"
                            type="checkbox"
                            data-key="tos"
                            name="user[eula_accepted]"
                            checked={this.state.tos}
                            failure={this.state.tosFailure}
                            onChange={this._updateInput} />
                }

                { false && // Disabling for now because of BO-3947 - User in China cannot create Bookshelf accounts due to reCaptcha
                  <div className="g-recaptcha" id="g-recaptcha" data-expired-callback="recaptchaExpiredCallback" data-error-callback="recaptchaErrorCallback"></div>}
                { false && // Disabling for now because of BO-3947 - User in China cannot create Bookshelf accounts due to reCaptcha
                  this.state.recaptchaError && <span role="alert" className="recaptcha-error">{i18n.t('signin.recaptcha')}</span>}

                <input type="hidden" name="return" id="login-return" value={redirect} />
                <input type="hidden" name="failure" id="login-return" value={failure} />

                <VstInput type="submit"
                          id="registration-submit"
                          options="btn-44 block"
                          className="registration-create inactive"
                          value={(this.props.completeAccount || this.state.emailLocked) ? i18n.t('base.finish') : i18n.t('base.create')} />
              </form>
            </div>

            {!this.props.completeAccount && !this.props.viaSSO &&
              <div className="subheading">
                {window.toHTML(i18n.t('registration.signin', {url: Fraction.registrationRedirect || "/#/user/signin"}))}
              </div>
            }

          </div>
        </div>
      </div>
    );
  }

}

module.exports = RegistrationContainer;
